import { OpenInNew } from '@mui/icons-material';
import { Box, Link } from '@mui/material';
import { Suspense } from 'react';
import { useApplicationContext } from '../../hooks/Context';
import { PathData, useData } from '../../hooks/UseData';

import React from 'react';

const findPath = (
  pathParts: string[],
  pathData: string | PathData
): string | undefined => {
  if (pathParts.length === 0) {
    if (typeof pathData === 'string') {
      return pathData;
    } else {
      return undefined;
    }
  } else {
    const firstPathPart = pathParts[0];
    if (firstPathPart === undefined || typeof pathData === 'string') {
      return undefined;
    }
    const subPathData = pathData[firstPathPart];
    if (subPathData === undefined) {
      return undefined;
    }
    return findPath(pathParts.slice(1), subPathData);
  }
};

const GoTheOtherSite: React.FC<GoTheOtherSiteButtonProps> = ({ path }) => {
  const { fetchTheOtherSitePathData } = useData();
  const {
    headerProps: { linkPath, buttonIconSmallSrc, buttonIconBackgroundColor },
  } = useApplicationContext();

  const pathData = fetchTheOtherSitePathData();
  const pathInTheOtherSite = findPath(
    path.split('/').filter((p) => p !== ''),
    pathData
  );
  if (pathInTheOtherSite === undefined) {
    return <></>;
  }
  const theOtherSitePathsPath = `${linkPath}${pathInTheOtherSite}`;

  return (
    <Link
      href={theOtherSitePathsPath}
      underline="none"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 'calc(1rem + 4px)', // 14px + 4px
        // height: '20px',
        px: 0.5, // 4px
        py: 0.25, // 2px
        ml: 2, // 4px
        backgroundColor: buttonIconBackgroundColor,
        borderRadius: 1, // 4px
        gap: 0.25, // 2px
      }}
    >
      <Box
        component="img"
        src="/img/button_go.svg"
        sx={{ height: '100%', aspectRatio: '1/1' }}
      />
      <Box
        component="img"
        src={buttonIconSmallSrc}
        sx={{ height: '100%', aspectRatio: '1/1' }}
      />

      <OpenInNew
        sx={{
          height: '100%', // 高さを画像を揃える
          width: 'auto', // デフォルトの1emを上書き
          color: '#fff',
        }}
      />
    </Link>
  );
};

export interface GoTheOtherSiteButtonProps {
  path: string;
}
export const GoTheOtherSiteButton: React.FC<GoTheOtherSiteButtonProps> = (
  props
) => (
  <Suspense fallback={<></>}>
    <GoTheOtherSite {...props} />
  </Suspense>
);
